/**
 * Redirect to an url via window.location.href
 * Encapsulating logic in this method allows easy mocking in unit tests.
 *
 * @param {string} url to be redirected
 */
export function redirect(url) {
    window.location.href = url;
}
